// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__jGnBw","gfeWrapper":"CalendarEvent_gfeWrapper__3sJwz"};